<template>
    <div class="site__body" data-order="order">
            <div class="block-space block-space--layout--after-header"></div>
            <div class="block">
                <div class="container container--max--xl">
                    <div class="row">
                      
                      <account-navigation></account-navigation>
                        <div class="col-12 col-lg-9 mt-4 mt-lg-0 text-center" v-if="isloading">
                          Loading...
                        </div>
                        <div class="col-12 col-lg-9 mt-4 mt-lg-0" >
                          <server-messages v-if="!isloading" :servermessages="servermessages" class="col-12 mt-4 mt-lg-0 mb-4"></server-messages>
                          <div v-if="!isloading && returncode === 'OK'">
                            <order-details-info :itemlist="itemlist" :orderinfo="orderinfo"></order-details-info>
                              <div class="row mt-3 no-gutters mx-n2">
                                <order-details-shipto :addressinfo="addressinfo"></order-details-shipto>
                                <order-details-billto :addressinfo="addressinfo"></order-details-billto>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-space block-space--layout--before-footer"></div>
        </div>
</template>

<script>

import axiosvl from "../../../axios/axios-vl.js";
import AccountNavigation from '../accountnavigation/AccountNavigation';
import OrderDetailsInfo from './OrderDetailsInfo';
import OrderDetailsShipto from './OrderDetailsShipTo';
import OrderDetailsBillto from './OrderDetailsBillTo';
import ServerMessages from '../../messages/Messages';

export default {
  name: 'OrderDetails',  
  components: {
    AccountNavigation,
    OrderDetailsInfo,
    OrderDetailsShipto,
    OrderDetailsBillto,
    ServerMessages    
  },
  props: {
    order: {
      type: Number,
      required: true
    },
  },
  provide() {
    return { 
      itemlist: this.itemlist,
    };
  },
  data () {
    return {
      isloading: false,
      error: '',
      returncode: '',
      servermessages: [],
      itemlist: [],
      addressinfo: [],
      orderinfo: [],
    }
  },
  methods: {
    loadOrderData() {
      console.log('loadOrderData');
      this.isloading = true;
      this.error, this.returncode = '';
      this.itemlist, this.adressinfo, this.orderinfo, this.servermessages = [];
      const order_details_uri = this.$store.getters['api/order_details_uri'];
      // "/D15PGMLIB/lansaweb?w=OrderHist&r=Order&vlweb=1&part=erp&lang=ENG&_T=1611072351543"
      axiosvl.post(order_details_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {
                          "value": this.$store.getters.customer
                      },
                      "EHORD#": {
                        "value": this.order
                      }
                  }
              }
          }
        )
        .then((response) => {
          const results = [];
          const fields = response.data.webroutine.fields
          console.log(fields);
          this.returncode = fields.RESULTCOD.value;
          let grandtotal = 0;
          if (this.returncode === 'OK') {
            for (const key in response.data.webroutine.lists.OSDET.entries) {
              const obj = response.data.webroutine.lists.OSDET.entries[key];
              results.push({
                OSDETL: obj.OSDETL,
                quantity: obj.DIORQT,
                DISHQW: obj.DISHQW,
                DIBOQX: obj.DIBOQX,
                DIMFGC: obj.DIMFGC,
                item: obj.DIITMC,
                desc: obj.DIDESC,
                price: obj.DIEPRX,
                core: obj.DICPRX,
                total: obj.TOLITM,
                DICUST: obj.DICUST,
                XRMFGC: obj.XRMFGC,
                XRITMC: obj.XRITMC,
                XRDESC: obj.XRDESC,
                DICPONUM: obj.DICPONUM,
                DIDISNUM: obj.DIDISNUM
              });
              grandtotal += obj.TOLITM;
            }

            this.itemlist = results;

            console.dir('grandtotal manual comp = ' + grandtotal);

            this.orderinfo.push({
              ordernumber: this.order,
              orderyear: fields.XROESY.value,
              ordermonth: fields.XROESM.value,
              orderday: fields.XROESD.value,
              totalamount: fields.TOLAMT.value,
              ponumber: fields.HACPO.value,
            });

            this.addressinfo.push({
              name: fields.ADNAME.value,
              locationsname: fields.LCNAME.value,
              locationlname: fields.LCNAMEL.value,
              address1: fields.ADADD1.value,
              address2: fields.ADADD2.value,
              city: fields.ADCITY.value,
              state: fields.ADSTTC.value,
              zip: fields.ADZIPC.value,
              phone: fields.ADPHON.value,
            });
          }

          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
            for (var i = 0; i < wrmessages.length; i++) {
                this.servermessages.push(wrmessages[i]);
            }
          }
          
          this.isloading = false;
        })
        .catch((error) => {
          console.log("error - " + error);
          this.servermessages.push('Failed to retrieve data. Please try again later.');
          this.isloading = false;
        });
    }
  },
  mounted() {
    this.loadOrderData();
  }
}
</script>